import BaseException from "exceptions/BaseException";

export default class InvalidFilterVariantException extends BaseException {
    readonly name = 'InvalidFilterVariantException';
}
